export default "__VITE_ASSET__w44zXvcL__";